import { render, staticRenderFns } from "./page-navigate-win3.vue?vue&type=template&id=7a2b4740&scoped=true"
import script from "./page-navigate-win3.vue?vue&type=script&lang=js"
export * from "./page-navigate-win3.vue?vue&type=script&lang=js"
import style0 from "./page-navigate-win3.vue?vue&type=style&index=0&id=7a2b4740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2b4740",
  null
  
)

export default component.exports